import { mode } from '@chakra-ui/theme-tools';
export const buttonStyles = {
	components: {
		Button: {
			baseStyle: {
				borderRadius: '12px',
				boxShadow: 'none',
				transition: '.18s all ease',
				boxSizing: 'border-box',
				fontFamily: '"Urbanist", "Figtree", sans-serif',
				fontWeight: '600',
				letterSpacing: '-0.01em',
				_focus: {
					boxShadow: 'none'
				},
				_active: {
					boxShadow: 'none'
				}
			},
			variants: {
				outline: () => ({
					borderRadius: '12px'
				}),
				brand: (props: any) => ({
					bg: mode('brand.500', 'brand.400')(props),
					color: 'white',
					_focus: {
						bg: mode('brand.500', 'brand.400')(props)
					},
					_active: {
						bg: mode('brand.600', 'brand.300')(props),
						transform: 'scale(0.98)',
					},
					_hover: {
						bg: mode('brand.600', 'brand.400')(props),
						boxShadow: 'brand',
						transform: 'translateY(-1px)',
					}
				}),
				darkBrand: (props: any) => ({
					bg: mode('brand.900', 'brand.400')(props),
					color: 'white',
					_focus: {
						bg: mode('brand.900', 'brand.400')(props)
					},
					_active: {
						bg: mode('brand.900', 'brand.400')(props)
					},
					_hover: {
						bg: mode('brand.800', 'brand.400')(props)
					}
				}),
				lightBrand: (props: any) => ({
					bg: mode('#F2EFFF', 'whiteAlpha.100')(props),
					color: mode('brand.500', 'white')(props),
					_focus: {
						bg: mode('#F2EFFF', 'whiteAlpha.100')(props)
					},
					_active: {
						bg: mode('secondaryGray.300', 'whiteAlpha.100')(props)
					},
					_hover: {
						bg: mode('secondaryGray.400', 'whiteAlpha.200')(props)
					}
				}),
				light: (props: any) => ({
					bg: mode('secondaryGray.300', 'whiteAlpha.100')(props),
					color: mode('secondaryGray.900', 'white')(props),
					_focus: {
						bg: mode('secondaryGray.300', 'whiteAlpha.100')(props)
					},
					_active: {
						bg: mode('secondaryGray.300', 'whiteAlpha.100')(props)
					},
					_hover: {
						bg: mode('secondaryGray.400', 'whiteAlpha.200')(props)
					}
				}),
				action: (props: any) => ({
					fontWeight: '500',
					borderRadius: '50px',
					bg: mode('secondaryGray.300', 'brand.400')(props),
					color: mode('brand.500', 'white')(props),
					_focus: {
						bg: mode('secondaryGray.300', 'brand.400')(props)
					},
					_active: { bg: mode('secondaryGray.300', 'brand.400')(props) },
					_hover: {
						bg: mode('secondaryGray.200', 'brand.400')(props)
					}
				}),
				setup: (props: any) => ({
					fontWeight: '500',
					borderRadius: '50px',
					bg: mode('transparent', 'brand.400')(props),
					border: mode('1px solid', '0px solid')(props),
					borderColor: mode('secondaryGray.400', 'transparent')(props),
					color: mode('secondaryGray.900', 'white')(props),
					_focus: {
						bg: mode('transparent', 'brand.400')(props)
					},
					_active: { bg: mode('transparent', 'brand.400')(props) },
					_hover: {
						bg: mode('secondaryGray.100', 'brand.400')(props)
					}
				}),
				modalCta: (props: any) => ({
					w: '100%',
					h: '48px',
					fontSize: 'md',
					fontWeight: '600',
					bg: mode('brand.500', 'brand.400')(props),
					color: 'white',
					borderRadius: '12px',
					_focus: {
						bg: mode('brand.500', 'brand.400')(props)
					},
					_active: {
						bg: mode('brand.600', 'brand.300')(props),
					},
					_hover: {
						bg: mode('brand.600', 'brand.400')(props),
						boxShadow: 'brand',
					}
				}),
				modalCtaDanger: (props: any) => ({
					w: '100%',
					h: '48px',
					fontSize: 'md',
					fontWeight: '600',
					bg: mode('danger.500', 'danger.500')(props),
					color: 'white',
					borderRadius: '12px',
					_focus: {
						bg: mode('danger.500', 'danger.500')(props)
					},
					_active: {
						bg: mode('danger.600', 'danger.600')(props),
					},
					_hover: {
						bg: mode('danger.600', 'danger.600')(props),
						boxShadow: '0px 4px 12px rgba(238, 93, 80, 0.35)',
					}
				})
			}
		}
	}
};
